











































































import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

import { PaginationMixin } from '@/utils/mixin';
import { addThirdForm, cloneThirdForm, deleteThirdForm, getThirdFormList1, IGetThirdFormListResponse1 } from '@/api/rg';
import ThirdFormEditorModal from './components/third-form-editor-modal.vue';

type RowType = IGetThirdFormListResponse1['items'][number];

@Component({
    components: {
        ThirdFormEditorModal
    }
})
export default class extends PaginationMixin {
    @State(state => state.cti.permission.rg_template)
    permission: boolean;
    rgId = 0;

    templateList: RowType[] = [];

    tableLoading = true;

    /** JSON 编辑器状态. */
    editorModalVisible = false;
    currentEditData = {};

    mounted() {
        this.initRgId();
        this.updateThirdFormList();
    }

    handleAddThirdTemplate() {
        this.currentEditData = {};
        this.editorModalVisible = true;
    }

    async handleCloneRow(row: RowType) {
        if (!this.permission) return;

        try {
            const { data } = await cloneThirdForm({ rgId: this.rgId, formId: row.id });
            data.customFieldContents.forEach(item => {
                item.ownerId = data.id;
            });
            await addThirdForm(data);
            this.$mtd.message.success('三方字段包复制成功');
            this.updateThirdFormList();
        } catch (e) {
            this.$mtd.message.error('三方字段包复制失败');
        }
    }

    async handleEditRow(row: RowType) {
        if (!this.permission) return;
        this.currentEditData = { ...row };
        this.editorModalVisible = true;
    }

    async handleDeleteRow(row: RowType) {
        if (!this.permission) return;

        this.$mtd
            .confirm({
                title: '你是否确认删除该字段包？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '删除',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    try {
                        await deleteThirdForm({
                            rgId: this.rgId,
                            formId: row.id
                        });
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await this.updateThirdFormList();
                    } catch (e) {
                        console.log(e);
                        this.$mtd.message.error('删除失败');
                    }
                }
            })
            .catch(e => e);
    }

    handleChangePage(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.updateThirdFormList();
    }

    formatRgs(permissionRgList: RowType['permissionRgList']) {
        return permissionRgList.map(item => item.rgName).join('、');
    }

    private initRgId() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
    }

    private async updateThirdFormList() {
        try {
            this.tableLoading = true;
            const { code, data } = await getThirdFormList1({
                cn: this.currentPage,
                sn: this.limit,
                rgId: this.rgId
            });
            if (code === 200) {
                this.templateList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.updateThirdFormList();
                }
            }
        } catch (e) {
            this.templateList = [];
        } finally {
            this.tableLoading = false;
        }
    }
}
